import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var EdadtwentyService = /** @class */ (function () {
    function EdadtwentyService(http) {
        this.http = http;
        this.cargadoEdadtwenty = true;
        this.edadtwenty = [];
        this.edadtwentyRFL = [];
        this.edadtwentyRFC = [];
        this.edadtwentyRFP = [];
        this.edadtwentyRCL = [];
        this.edadtwentyRCC = [];
        this.edadtwentyRCP = [];
        this.edadtwentyRCC_PSen = [];
        this.edadtwentyRCC_PSec = [];
        this.cargarEdadtwenty();
    }
    EdadtwentyService.prototype.cargarEdadtwenty = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.edadtwenty = resp;
                _this.edadtwentyRFL = _this.edadtwenty[0].rutinafacial.limpieza;
                _this.edadtwentyRFC = _this.edadtwenty[0].rutinafacial.cuidado;
                _this.edadtwentyRFP = _this.edadtwenty[0].rutinafacial.proteccion;
                _this.edadtwentyRCL = _this.edadtwenty[0].rutinacorporal.limpieza;
                _this.edadtwentyRCC = _this.edadtwenty[0].rutinacorporal.cuidado;
                _this.edadtwentyRCP = _this.edadtwenty[0].rutinacorporal.proteccion;
                _this.edadtwentyRCC_PSen = _this.edadtwenty[0].rutinacorporal.cuidado_piel_sensible;
                _this.edadtwentyRCC_PSec = _this.edadtwenty[0].rutinacorporal.cuidado_piel_seca;
                setTimeout(function () {
                    _this.cargadoEdadtwenty = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    EdadtwentyService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    EdadtwentyService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], EdadtwentyService);
    return EdadtwentyService;
}());
export { EdadtwentyService };
//# sourceMappingURL=edadtwenty.service.js.map